import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? 'AIzaSyDwb3cKCvodffB6uFMfnXppt4_LE6Tc8_c',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? 'zamanindatuket.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? 'zamanindatuket',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? 'zamanindatuket.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? '1084465966302',
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? '1:1084465966302:web:abd14a814977cbca12a64f',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? 'G-VS6FGRJX9F',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
